import axios from 'axios'
import {Buffer} from 'buffer';

export const API_URL = process.env.REACT_APP_API_URL

const params = new URLSearchParams(window.location.search)
const uuid = params.get('uuid')
const email = params.get('email')
const token = Buffer.from(`${uuid}:${email}`, 'utf8').toString('base64')

// Create instance called instance
const instance = axios.create({
  baseUrl: API_URL,
})

instance.defaults.headers.patch['Content-Type'] = 'application/vnd.api+json'
instance.defaults.headers.patch['Accept'] = 'application/vnd.api+json'
instance.defaults.headers.common['Authorization'] = `Basic ${token}`
instance.defaults.baseURL = API_URL

export default {
  getPages: () => instance.get('/api/signature-request-client-pages/' + uuid + '?_format=json'),
  getSignatureRequest: () => instance.get('/jsonapi/signature_request/signature_request/' + uuid),
  patchSignatureRequest: (data) => instance.patch('/jsonapi/signature_request/signature_request/' + uuid, data),
  getExpirePage: () => axios.get(API_URL + '/api/signature-request-client-expire-page?_format=json'),
}
